import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const QuantomeContact = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div id='about123'>
      <div className='container'>
        <div className='row'>
          <div className='col-xs-12 col-md-12'>
          </div>
          <h2>Quantum Shield is more than just a certificate checker.</h2>
          <p>
            <strong>
              It's a powerful tool that helps your organization identify quantum vulnerabilities,
              understand cryptographic risks, and take proactive steps toward post-quantum security
              — ultimately safeguarding your digital infrastructure against tomorrow's threats.
            </strong>
            <br />
            Contact us today to learn more about securing your organisation with Quantum Shield!
          </p>
          <div style={{ marginBottom: 20, display: 'flex', justifyContent: 'center', alignItems: 'center' }} className='px-5 py-4 pb-5'>
            <a href='/careers'>
              <button type='submit' style={{ fontWeight: 'bold' }} className='btn btn-custom btn-lg page-scroll' data-aos='fade-up'>
                Get In Touch With Us
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuantomeContact;
